import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedCategories from './components/FeaturedCategories';
import FeaturedProducts from './components/FeaturedProducts';
import FeaturedArticles from './components/FeaturedArticles';
import BrandStory from './components/BrandStory';
import FAQ from './components/FAQ';
import useSEO from '@/hooks/useSEO';
import { faqItems } from '@/mocks/faq';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '掌中之物',
      url: 'https://szatmkj.cn',
      description: '掌中之物专注于每一件值得被双手珍视的精品，从选材到工艺，从触感到故事，每一件掌中之物都承载着独特的温度与价值。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://szatmkj.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '掌中之物',
      url: 'https://szatmkj.cn',
      description: '掌中之物专注于精品收藏，涵盖文玩把件、工艺摆件、茶器茶具、收藏精品等品类。',
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    },
  ],
};

export default function Home() {
  useSEO({
    title: '让你爱不释手的精品收藏',
    description: '掌中之物专注于每一件值得被双手珍视的精品，从选材到工艺，从触感到故事，每一件掌中之物都承载着独特的温度与价值。探索属于你的掌中之物，感受方寸之间的无限魅力。',
    keywords: '掌中之物,掌中之物精品收藏,掌中之物工艺品,掌中之物把玩件,掌中之物选购指南,掌中之物礼品,掌中之物文玩',
    canonicalUrl: 'https://szatmkj.cn',
    schema: homepageSchema,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedCategories />
        <FeaturedProducts />
        <FeaturedArticles />
        <BrandStory />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}